import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import type { CreateElement } from '../../../../node_modules/vue';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';
import imagePreview from '@/views/components/imgPreview';
import GenerateLink from '@/views/components/generateLink';
import { noop } from '@/util';

export enum MiniPageState {
  DISABLED,
  ABLED,
  TEMPORARY, // 暂存
  ALL = 9,
}

export const PageState = [
  { label: '不可用', value: MiniPageState.DISABLED },
  { label: '可用', value: MiniPageState.ABLED },
  { label: '暂存', value: MiniPageState.TEMPORARY },
  { label: '全部', value: MiniPageState.ALL },
];

const PageListService = ['miniPageList', 'miniPageList', 'miniPageList', 'siteMicroPageList', 'miniPageList'];
const PageUpdateStateService = ['miniPageUpdate', 'miniPageUpdate', 'miniPageUpdate', 'siteMicroPageUpdateState', 'miniPageUpdate'];
const PageDeleteService = ['miniPageDelete', 'miniPageDelete', 'miniPageDelete', 'siteMicroPageDelete', 'miniPageDelete'];
const PageInfoService = ['miniPageInfo', 'miniPageInfo', 'miniPageInfo', 'siteMicroPageInfo', 'miniPageInfo'];
const PagePreviewService = ['miniPagePreview', 'miniPagePreview', 'miniPagePreview', 'siteMicroPageConfigDisplay', 'miniPagePreview'];

@Component({
  components: {
    imagePreview,
  },
})
export default class MiniPage extends Vue {
  @Prop()
    value: boolean;

  @Prop()
    siteId: number;

  tableData: Array<MiniPageTable> = [];

  keyword = '';

  onSelected: ItemObject = {};

  empCode = '';

  page = 1;

  pageSize = 10;

  totalCount = 0;

  pageState = 9;

  // 2 or 3 控制调用微页面接口
  get serviceIndex() {
    return +this.$route.params.siteId ? 3 : 2;
  }

  @Watch('value', { immediate: true })
  watchValue(n) {
    if (n) {
      this.clearData();
      this.getTableData();
    }
  }

  mounted() {
    this.empCode = this.$store.state.empCode;
  }

  clearData() {
    this.tableData = [];
    this.keyword = '';
    this.page = 1;
    this.pageSize = 10;
    this.totalCount = 0;
  }

  handleSearch() {
    this.page = 1;
    this.getTableData();
  }

  renderTableBtn(h, val) {
    const { pageState, pageId, operAuthority } = val;
    if (operAuthority === 0) {
      return (
        <p>
          <span class="scopeSpan" onClick={this.onEdit.bind(this, pageId, 1)}>
            查看
          </span>
        </p>
      );
    }
    return (
      <p>
        {(pageState === MiniPageState.ABLED || pageState === MiniPageState.TEMPORARY) && (
          <span class="scopeSpan" onClick={this.onEdit.bind(this, pageId, 0)}>
            配置
          </span>
        )}
        {/* <span class="scopeSpan" onClick={this.onLink.bind(this, val)}>
          链接
        </span> */}
        <span class="scopeSpan" onClick={this.preview.bind(this, pageId)}>
          预览
        </span>
        {pageState === MiniPageState.ABLED && (
          <span class="scopeSpan" onClick={this.onDisabled.bind(this, pageId, 0)}>
            禁用
          </span>
        )}
        {pageState === MiniPageState.DISABLED && (
          <span class="scopeSpan" onClick={this.onDisabled.bind(this, pageId, 1)}>
            启用
          </span>
        )}
        <span class="scopeSpan" onClick={this.onDel.bind(this, pageId)}>
          删除
        </span>
      </p>
    );
  }

  onDel(id) {
    this.$confirm('是否删除？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      type: 'warning',
    }).then((res) => {
      if (res == 'confirm') {
        IPSService[PageDeleteService[this.serviceIndex]]({
          postParams: {
            pageId: id,
          },
        }).then(() => {
          this.$message.success('删除成功');
          this.getTableData();
        });
      }
    }, noop);
  }

  preview(pageId) {
    const loading = this.$loading({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(225,225,225,0.3)',
    });
    IPSService[PageInfoService[this.serviceIndex]]({
      postParams: {
        pageId,
      },
    }).then(
      (res) => {
        IPSService[PagePreviewService[this.serviceIndex]]({
          postParams: Object.assign({}, res, {
            sgId: Number(this.$route.params.id),
            siteId: Number(this.$route.params.siteId),
          }),
        }).then(
          (result) => {
            loading.close();
            imagePreview.open({ img: result.disPlayUrl }).catch(() => {});
          },
          () => {
            loading.close();
          },
        );
      },
      () => {
        loading.close();
      },
    );
  }

  onLink(item) {
    GenerateLink.open({
      item,
      title: '微页面链接',
      type: 'tiny',
    }).then(noop, noop);
  }

  onDisabled(pageId, pageState) {
    if (!pageState) {
      this.$confirm('确定要将当前微页面置为不可用状态吗？如该微页面被引用，引用将失效，请及时处理！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning',
      }).then((res) => {
        if (res == 'confirm') {
          IPSService[PageUpdateStateService[this.serviceIndex]]({
            postParams: {
              pageId,
              pageState,
            },
          }).then(() => {
            this.getTableData();
          });
        }
      }, noop);
    } else {
      IPSService[PageUpdateStateService[this.serviceIndex]]({
        postParams: {
          pageId,
          pageState,
        },
      }).then(() => {
        this.getTableData();
      });
    }
  }

  onEdit(pageId, state = 0) {
    this.$emit('edit', pageId, state);
  }

  getTableData() {
    const loading = this.$loading({
      lock: true,
      text: '请稍等...',
      spinner: 'el-icon-loading',
      background: 'rgba(225,225,225,0.3)',
    });
    IPSService[PageListService[this.serviceIndex]]({
      postParams: {
        page: this.page,
        pageSize: this.pageSize,
        keyword: this.keyword,
        sgId: Number(this.$route.params.id),
        siteId: Number(this.$route.params.siteId),
        pageState: this.pageState,
      },
    })
      .then((response) => {
        loading.close();
        this.tableData = response.list.map((v) => {
          v.pageStateStr = PageState[v.pageState].label;
          v.updateTimeStr = Functions.timeFormat(v.updateTime);
          return v;
        });
        this.totalCount = response.count;
      })
      .catch((error) => {
        loading.close();
      });
  }

  onSizeChange(val) {
    this.page = 1;
    this.pageSize = val;
    this.getTableData();
  }

  onPageChange(val) {
    this.page = val;
    this.getTableData();
  }

  stateChange(val) {
    this.getTableData();
  }

  render(h: CreateElement) {
    return this.value ? (
      <div style="height: 100%">
        <div class="filterController">
          <div class="inputWrapper">
            <el-input v-model={this.keyword} placeholder="微页面名称" onEnter={this.handleSearch.bind(this)}></el-input>
            <i class="iconfont iconsousuo" onClick={this.handleSearch.bind(this)}></i>
          </div>
          <el-select v-model={this.pageState} onChange={val => this.stateChange(val)}>
            {PageState.map((v) => {
              return <el-option label={v.label} value={v.value}></el-option>;
            })}
          </el-select>
        </div>
        <el-table class="el-table" element-loading-text="加载中" width="100%" height="calc(100% - 107px)" data={this.tableData} tooltip-effect="light">
          <el-table-column type="index" label="#" width="80px" align="center" />
          <el-table-column prop="pageId" label="页面ID" show-overflow-tooltip width="120px" align="center" />
          <el-table-column prop="pageName" label="页面名称" show-overflow-tooltip min-width={4} align="left" />
          <el-table-column prop="pageStateStr" label="状态" show-overflow-tooltip min-width={1} align="center" />
          <el-table-column prop="updatePerson" label="更新人" show-overflow-tooltip min-width={1} align="center" />
          <el-table-column prop="updateTimeStr" label="更新时间" show-overflow-tooltip min-width={2} align="center" />
          <el-table-column
            label="操作"
            width="210"
            min-width={2}
            fixed="right"
            align="center"
            {...{
              scopedSlots: {
                default: (scope) => {
                  return this.renderTableBtn(h, scope.row);
                },
              },
            }}
          />
        </el-table>
        <div class="bottomWrapper">
          <el-button type="primary" onClick={this.onEdit.bind(this, 0, 0)}>
            追加微页面
          </el-button>
          <el-pagination
            on-size-change={e => this.onSizeChange(e)}
            on-current-change={e => this.onPageChange(e)}
            current-page={this.page}
            page-sizes={[10, 15, 20, 30]}
            page-size={this.pageSize}
            layout="total, sizes, prev, pager, next, jumper"
            total={this.totalCount}
          />
        </div>
      </div>
    ) : (
      ''
    );
  }
}
